export default "https://widget.myclimate.org/assets/images/quiz/myclimate_Klimabooklet_2020_Cover_RGB.jpg";